import { render, staticRenderFns } from "./xxhdDocument.vue?vue&type=template&id=f489ea1c&scoped=true&%40scroll.native=handleScroll&"
import script from "./xxhdDocument.vue?vue&type=script&lang=js&"
export * from "./xxhdDocument.vue?vue&type=script&lang=js&"
import style0 from "./xxhdDocument.vue?vue&type=style&index=0&id=f489ea1c&scoped=true&lang=less&"
import style1 from "./xxhdDocument.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f489ea1c",
  null
  
)

export default component.exports